/**
 * EnforcementUnifiedPage - Consolidates Complaints + Violations/Notices + Analytics
 */
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Gavel, AlertTriangle, BarChart3 } from "lucide-react";

import ComplaintsPage from "./ComplaintsPage";
import ViolationsPage from "./ViolationsPage";
import ComplaintAnalyticsDashboard from "./ComplaintAnalyticsDashboard";

const EnforcementUnifiedPage = () => {
  const [activeTab, setActiveTab] = useState("complaints");

  return (
    <div data-testid="enforcement-unified-page" className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold font-serif">Enforcement</h1>
        <p className="text-muted-foreground">Complaints, notices, investigations, and analytics</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-4">
          <TabsTrigger value="complaints" data-testid="tab-complaints" className="gap-2">
            <Gavel className="w-4 h-4" /> Complaints
          </TabsTrigger>
          <TabsTrigger value="notices" data-testid="tab-notices" className="gap-2">
            <AlertTriangle className="w-4 h-4" /> Notices
          </TabsTrigger>
          <TabsTrigger value="analytics" data-testid="tab-analytics" className="gap-2">
            <BarChart3 className="w-4 h-4" /> Analytics
          </TabsTrigger>
        </TabsList>

        <TabsContent value="complaints">
          <ComplaintsPage embedded />
        </TabsContent>
        <TabsContent value="notices">
          <ViolationsPage isBoard embedded />
        </TabsContent>
        <TabsContent value="analytics">
          <AnalyticsInner />
        </TabsContent>
      </Tabs>
    </div>
  );
};

const AnalyticsInner = () => <div data-testid="analytics-content"><ComplaintAnalyticsDashboard embedded /></div>;

export default EnforcementUnifiedPage;
